import * as React from "react";
import { Box } from "@mui/material";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import { DataGrid } from "@mui/x-data-grid";
import { faIR } from "@mui/x-data-grid/locales";
import createCache from "@emotion/cache";
import { CacheProvider } from "@emotion/react";
import { createTheme, ThemeProvider, useTheme } from "@mui/material/styles";
import { rows, columns } from "./components/TeamReportTestData";

const cacheRtl = createCache({
  key: "data-grid-rtl-demo",
  stylisPlugins: [prefixer, rtlPlugin],
});

export default function TeamReport() {
  const existingTheme = useTheme();
  const theme = React.useMemo(
    () =>
      createTheme({}, faIR, existingTheme, {
        direction: "rtl",
      }),
    [existingTheme],
  );

  return (
    <Box
      sx={{
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#fff",
        marginBottom: 3,
        padding: 2,
      }}
    >
      <CacheProvider value={cacheRtl}>
        <ThemeProvider theme={theme}>
          <div dir="rtl" style={{ height: 460, width: "100%" }}>
            <DataGrid
              rows={rows}
              columns={columns}
              sx={{
                borderColor:
                  theme.palette.mode === "dark"
                    ? theme.palette.grey[700]
                    : theme.palette.grey[200],
                "& .MuiDataGrid-cell": {
                  borderColor:
                    theme.palette.mode === "dark"
                      ? theme.palette.grey[700]
                      : theme.palette.grey[200],
                },
              }}
            />
          </div>
        </ThemeProvider>
      </CacheProvider>
    </Box>
  );
}
